import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ChevronDown } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const faqs = [
  { q: "Gusto est-il gratuit ?", a: "Oui, l'utilisation de base est 100% gratuite pour les particuliers. Les fonctionnalités avancées pour les professionnels peuvent nécessiter un abonnement." },
  { q: "Comment créer une recette ?", a: "Appuyez sur le bouton '+' en bas de l'écran, puis 'Nouvelle recette'. Vous pouvez dicter vos étapes en cuisinant : l'IA reconnaît les ingrédients, quantités et actions automatiquement." },
  { q: "Comment scanner un ticket de caisse ?", a: "Allez dans 'Scanner ticket' depuis le menu '+'. Prenez une photo de votre ticket et l'IA extraira automatiquement les produits et les prix." },
  { q: "Comment inviter mes amis à noter mon plat ?", a: "Après avoir cuisiné une recette, cliquez sur 'Inviter mes convives à noter'. Un lien unique sera généré que vous pourrez partager. Vos invités pourront noter votre plat sur 4 critères." },
  { q: "Comment fonctionne le scanner de frigo ?", a: "Prenez en photo le contenu de votre frigo. L'IA identifiera les ingrédients disponibles et vous proposera des recettes réalisables." },
  { q: "Mes données sont-elles sécurisées ?", a: "Oui, vos données sont hébergées en France et protégées conformément au RGPD. Consultez notre politique de confidentialité pour plus de détails." },
  { q: "Comment devenir un commerce partenaire ?", a: "Rendez-vous sur 'Inscrire mon commerce' depuis la page d'accueil ou le menu. Créez votre profil pro et commencez à gérer votre vitrine en ligne." },
  { q: "Comment fonctionne le système de points ?", a: "Vous gagnez des points en créant des recettes, en recevant des notes, en invitant des amis, etc. Ces points vous permettent de monter en niveau dans le classement des chefs." },
  { q: "Puis-je noter de manière anonyme ?", a: "Oui, lors de la notation d'un plat, vous pouvez activer l'option 'Noter en anonyme'. Le chef ne verra pas votre nom." },
  { q: "Comment contacter le support ?", a: "Rendez-vous sur la page Support accessible depuis le footer ou via le menu. Remplissez le formulaire et notre équipe vous répondra sous 24h." },
];

const FAQItem = ({ q, a }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-gray-100 last:border-0">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between py-4 text-left gap-4">
        <span className="font-medium text-sm text-charcoal">{q}</span>
        <ChevronDown className={`w-4 h-4 text-muted-foreground flex-shrink-0 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <AnimatePresence>
        {open && (
          <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: "auto", opacity: 1 }} exit={{ height: 0, opacity: 0 }} className="overflow-hidden">
            <p className="text-sm text-muted-foreground pb-4 leading-relaxed">{a}</p>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

const FAQPage = () => (
  <div className="px-4 py-8 max-w-2xl mx-auto">
    <Link to="/" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-charcoal mb-6">
      <ArrowLeft className="w-4 h-4" /> Retour
    </Link>
    <h1 className="font-heading text-2xl font-bold text-charcoal mb-2">Questions fréquentes</h1>
    <p className="text-muted-foreground text-sm mb-6">Trouvez rapidement les réponses à vos questions.</p>
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-5" data-testid="faq-list">
      {faqs.map((f, i) => <FAQItem key={i} q={f.q} a={f.a} />)}
    </div>
    <p className="text-center text-sm text-muted-foreground mt-8">
      Vous ne trouvez pas votre réponse ? <Link to="/support" className="text-primary font-medium hover:underline">Contactez le support</Link>
    </p>
  </div>
);

export default FAQPage;
